import { useState } from "react";
import {
  useBlockUnblockPricingPlanMutation
} from "../Data/services/userApi";
import Toast from "../Hooks/useToast";
import LoadingButton from "./CustomComponents/LoadingButton";
import DeleteModal from "./Modals/DeleteModal";

const SubscribersBox = ({ dt, refetch }) => {
  const [blockModal, setBlockModal] = useState(false);
  const [
    blockUnblockUser,
    {
      isSuccess: isSuccessBlock,
      isLoading: isLoadingBlock,
      isError: isErrorBlock,
    },
  ] = useBlockUnblockPricingPlanMutation();

  const blockUnblockSubmit = async () => {
    let response;
    try {
      response = await blockUnblockUser(dt?.id).unwrap();

      Toast(response?.message, "success");
      setBlockModal(false);
      refetch();
    } catch (error) {
      // Handle errors
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error");
      }
    }
  };
  return (
    <div className="subscriber-box d-flex flex-column w-100 mb-3">
      {blockModal ? (
        <DeleteModal
          handleDeleteModalClose={() => setBlockModal(false)}
          //   data={dt}
          cnfrmtext={
            dt?.is_blocked === true
              ? "Active Pricing Plan"
              : "In Active Pricing Plan"
          }
          text={dt?.is_blocked === true ? "Active" : "In Active"}
          cnfrm={isLoadingBlock ? <LoadingButton /> : "Confirm"}
          cancel={"Cancel"}
          onDelete={blockUnblockSubmit}
        />
      ) : (
        ""
      )}
      <div className="d-flex justify-content-between align-items-center">
        <h4>Name:</h4>
        <p className="m-0 p-0">{dt?.name}</p>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <h4>Billing Period:</h4>
        <p className="m-0 p-0">{dt?.billing_period}</p>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <h4>Status:</h4>
        {!dt?.is_blocked ? (
          <p className="text-white m-0 p-1 badge bg-success">Active</p>
        ) : (
          <p className="text-danger text-white m-0 p-0 p-1 badge bg-danger">
            In Active
          </p>
        )}
      </div>
      <div className="ms-auto my-4">
        {!dt?.is_blocked ? (
          <div
            className={"block-btn cursor-pointer"}
            onClick={() => setBlockModal(true)}
          >
            In Active Pricing Plan
          </div>
        ) : (
          <div
            className={"active-btn cursor-pointer"}
            onClick={() => setBlockModal(true)}
          >
            Active Pricing Plan
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscribersBox;
